/**
 * Format an account number - a space is added after every 4th digit (or character)
 * @param accountNumber
 * @returns {string}
 */
export const formatAccount = accountNumber =>
    accountNumber ? accountNumber.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ').trim() : '';
